import {ThemeProvider as TP} from "styled-components";

export const ThemeProvider = TP

const guessHeightPX = 28
const guessGapPX = 4

const colorWrong = '#FF6B6B'
const colorRight = '#6BCB77'
const colorLightGray = '#666666';
const colorLighterGray = '#999999;'
const colorDark = '#1a1a1a'
const colorDarkish = '#333333';
const colorPrimary = '#4D96FF'
const colorSecondary = '#d5e6ff'

const theme = {
	maxWidthPX: 600,
	colorAnswerRevealBG: '#ccc',
	colorPrimary,
	colorSkipBackground: colorSecondary,
	colorSkipText: 'inherit',
	colorPrimaryOpposite: 'inherit',
	colorSecondary: colorSecondary,
	tilesSidePadding: 5,
	colorDark: colorDark,
	colorDarkish: colorDarkish,
	colorText: '#fff',
	colorLighterGray,
	colorWrong: colorWrong,
	colorRight: colorRight,
	actionsHeightPX: 80,
	guessGapPX: guessGapPX,
	guessHeightPX: guessHeightPX,
	guessesHeightPX: (guessHeightPX * 5) + (guessGapPX * 6),
	guessColors: {
		correct: {
			border: colorRight,
		},
		wrong: {
			text: colorLightGray,
			border: colorWrong,
		},
		skip: {
			text: colorLightGray,
			border: colorLightGray,
		},
		waiting: {
			text: colorDarkish,
			border: colorDarkish,
		},
	}
}

export default theme

